// extracted by mini-css-extract-plugin
export default {"wrapper":"errorMessage_wrapper__kJHuL"};